module.exports = __webpack_public_path__ + "media/about/commercial-0bea2012.jpg";